import captureClientAxiosError from './captureClientAxiosError';
import captureServerAxiosError from './captureServerAxiosError';

import type { AxiosError, AxiosRequestConfig } from 'axios';

type AxiosErrorCustomConfig = AxiosRequestConfig & {
  isValidate: boolean;
};

const captureAxiosError = (error: AxiosError) => {
  const isClient = typeof window !== 'undefined';
  if (isClient) {
    captureClientAxiosError(error);
  } else {
    captureServerAxiosError(error);
  }
};

export default captureAxiosError;
